import React from 'react';
import './Styles/Popup.css';

export const Popup = props => {
  return (
    <div className="Popup__Container" onClick={() => props.onClose()}>
      <div className="Popup__Content">
        <i
          className="fas fa-times-circle button"
          onClick={() => props.onClose()}
        />
        <h2>{props.message}</h2>
        <ul>
          {props.data
            ? props.data.map(item => {
                return <li key={item.substr(0, 10)}>{item}</li>;
              })
            : undefined}
        </ul>
      </div>
    </div>
  );
};
